function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { Button } from '@ori-ui/components';
import { Grid, Link, styled } from '@ori-ui/mui';
export var ButtonWrapper = styled(Grid)(function() {
    return {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    };
});
export var ButtonSave = styled(Button)(function(param) {
    var theme = param.theme;
    return _define_property({
        margin: theme.spacing(0, 0, 2, 0),
        width: '330px',
        height: '46px',
        maxWidth: '100%'
    }, theme.breakpoints.down('sm'), {
        '&.Mui-disabled': {
            backgroundColor: theme.palette.grey.A100
        }
    });
});
export var ToggleStyled = styled(Link)(function() {
    return {
        cursor: 'pointer',
        fontSize: '12px'
    };
});
